// Auto-generated mapping of all Pandas components

import Pandas_CleaningData from "./pandas_components/Pandas_CleaningData.jsx";
import Pandas_CleaningEmptyCells from "./pandas_components/Pandas_CleaningEmptyCells.jsx";
import Pandas_CleaningWrongData from "./pandas_components/Pandas_CleaningWrongData.jsx";
import Pandas_CleaningWrongFormat from "./pandas_components/Pandas_CleaningWrongFormat.jsx";
import Pandas_DataFramesReference from "./pandas_components/Pandas_DataFramesReference.jsx";
import Pandas_AnalyzingData from "./pandas_components/Pandas_AnalyzingData.jsx";
import Pandas_Certificate from "./pandas_components/Pandas_Certificate.jsx";
import Pandas_Correlations from "./pandas_components/Pandas_Correlations.jsx";
import Pandas_DataFrames from "./pandas_components/Pandas_DataFrames.jsx";
import Pandas_Editor from "./pandas_components/Pandas_Editor.jsx";
import Pandas_Exercises from "./pandas_components/Pandas_Exercises.jsx";
import Pandas_Getting_Started from "./pandas_components/Pandas_Getting_Started.jsx";
import Pandas_Home from "./pandas_components/Pandas_Home.jsx";
import Pandas_Intro from "./pandas_components/Pandas_Intro.jsx";
import Pandas_Plotting from "./pandas_components/Pandas_Plotting.jsx";
import Pandas_Quiz from "./pandas_components/Pandas_Quiz.jsx";
import Pandas_Read_CSV from "./pandas_components/Pandas_Read_CSV.jsx";
import Pandas_Read_JSON from "./pandas_components/Pandas_Read_JSON.jsx";
import Pandas_Series from "./pandas_components/Pandas_Series.jsx";
import Pandas_StudyPlan from "./pandas_components/Pandas_StudyPlan.jsx";
import Pandas_Syllabus from "./pandas_components/Pandas_Syllabus.jsx";
import Pandas_RemovingDuplicates from "./pandas_components/Pandas_RemovingDuplicates.jsx";

const AllPandasComponents = {
  "<Pandas_CleaningData />": Pandas_CleaningData,
  "<Pandas_CleaningEmptyCells />": Pandas_CleaningEmptyCells,
  "<Pandas_CleaningWrongData />": Pandas_CleaningWrongData,
  "<Pandas_CleaningWrongFormat />": Pandas_CleaningWrongFormat,
  "<Pandas_DataFramesReference />": Pandas_DataFramesReference,
  "<Pandas_AnalyzingData />": Pandas_AnalyzingData,
  "<Pandas_Certificate />": Pandas_Certificate,
  "<Pandas_Correlations />": Pandas_Correlations,
  "<Pandas_DataFrames />": Pandas_DataFrames,

  "<Pandas_Editor />": Pandas_Editor,
  "<Pandas_Exercises />": Pandas_Exercises,
  "<Pandas_Getting_Started />": Pandas_Getting_Started,
  "<Pandas_Home />": Pandas_Home,
  "<Pandas_Intro />": Pandas_Intro,
  "<Pandas_Plotting />": Pandas_Plotting,
  "<Pandas_Quiz />": Pandas_Quiz,
  "<Pandas_Read_CSV />": Pandas_Read_CSV,
  "<Pandas_Read_JSON />": Pandas_Read_JSON,
  "<Pandas_Series />": Pandas_Series,
  "<Pandas_StudyPlan />": Pandas_StudyPlan,
  "<Pandas_Syllabus />": Pandas_Syllabus,
  "<Pandas_RemovingDuplicates />": Pandas_RemovingDuplicates,
};

export default AllPandasComponents;
